import React from "react";
import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import USER_PATHS from "../USER_PATHS";

function CherryIcon({ className = "" }) {
  return (
    <svg viewBox="0 0 64 64" className={className} role="img" aria-label="Cherrfy">
      <path
        d="M34 30c0-10 7-18 16-22"
        fill="none"
        stroke="#166534"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path d="M52 8c-6 1-11 6-12 12 6-1 11-6 12-12Z" fill="#22c55e" />
      <circle cx="24" cy="40" r="10" fill="#ef4444" />
      <circle cx="20" cy="36" r="3" fill="#fecaca" />
      <circle cx="40" cy="44" r="10" fill="#fb7185" />
      <circle cx="36" cy="40" r="3" fill="#ffe4e6" />
      <path
        d="M24 30c5 0 8 4 10 10"
        fill="none"
        stroke="#166534"
        strokeWidth="4"
        strokeLinecap="round"
      />
      <path
        d="M40 34c-3 0-6 3-6 8"
        fill="none"
        stroke="#166534"
        strokeWidth="4"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SettingsRing() {
  return (
    <div
      className="relative h-28 w-28 animate-[spin_3.2s_linear_infinite] motion-reduce:animate-none text-rose-500"
      aria-hidden="true"
    >
      <Icons.Settings className="absolute left-1/2 top-0 h-5 w-5 -translate-x-1/2" />
      <Icons.Settings className="absolute right-0 top-1/2 h-5 w-5 -translate-y-1/2" />
      <Icons.Settings className="absolute left-1/2 bottom-0 h-5 w-5 -translate-x-1/2" />
      <Icons.Settings className="absolute left-0 top-1/2 h-5 w-5 -translate-y-1/2" />
    </div>
  );
}

const Page404 = () => {
  return (
    <section className="min-h-[72vh] bg-white flex items-center justify-center px-4 py-10">
      <div className="relative mx-auto flex w-full max-w-xl flex-col items-center text-center">
        <div className="relative h-28 w-28">
          <SettingsRing />
          <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
            <CherryIcon className="h-14 w-14 -translate-y-[2px]" />
          </div>
        </div>

        <div className="mt-5 inline-flex items-center rounded-full border border-slate-200 px-3 py-1 text-[11px] font-semibold uppercase tracking-wide text-slate-600">
          404 Error
        </div>
        <h1 className="mt-3 text-4xl font-black tracking-tight text-slate-900 sm:text-5xl">Page not found</h1>
        <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-600">
          The page may have moved or no longer exists. Please go back and try another page.
        </p>

        <div className="mt-5 flex w-full flex-wrap items-center justify-center gap-2">
          <Link
            to={USER_PATHS.HOME}
            className="inline-flex h-9 items-center justify-center rounded-lg bg-[#D2042D] px-3.5 text-xs font-semibold text-white transition-colors hover:bg-[#b80326]"
          >
            Go to Home
          </Link>
          <Link
            to={USER_PATHS.CATEGORIES}
            className="inline-flex h-9 items-center justify-center rounded-lg border border-slate-300 px-3.5 text-xs font-semibold text-slate-800 transition-colors hover:bg-slate-50"
          >
            Browse Categories
          </Link>
        </div>

        <div className="mt-3 flex flex-wrap items-center justify-center gap-3 text-[11px] font-medium text-slate-500">
          <Link to={USER_PATHS.TRACK_ORDER} className="hover:text-[#D2042D]">
            Track Order
          </Link>
          <Link to={USER_PATHS.CONTACT} className="hover:text-[#D2042D]">
            Contact Support
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Page404;
